import React from "react";
import ExploreUnderstandWhite from 'src/images/algolia_explore_understand_white.svg'
import MeasureTrackWhite from 'src/images/algolia_measure_track_white.svg'
import PlanActWhite from 'src/images/algolia_plan_act_white.svg'
import StorytellingCultureChangeWhite from 'src/images/algolia_storytelling_culture_change_white.svg'

const CategoryIcon = ({props, isRefined}) => {
    switch (props) {
      case 'Explore & Understand':
        return <ExploreUnderstandWhite className={`h-6 w-6 fill-current lg:text-white text-darkgrey group-hover:text-red duration-300 ${isRefined ? '!text-red' : ''}`}/>
      case 'Measure & Track':
        return <MeasureTrackWhite className={`h-6 w-6 fill-current stroke-current stroke-[0.4px] lg:text-white text-darkgrey group-hover:text-red duration-300 ${isRefined ? '!text-red' : ''}`}/>
      case 'Plan & Act':
        return <PlanActWhite className={`h-6 w-6 fill-current lg:text-white text-darkgrey group-hover:text-red duration-300 ${isRefined ? '!text-red' : ''}`}/>
      case 'Storytelling & Culture Change':
        return <StorytellingCultureChangeWhite className={`h-6 w-6 fill-current lg:text-white text-darkgrey group-hover:text-red duration-300 ${isRefined ? '!text-red' : ''}`}/>
      default:
        return ''
    }
}

export default CategoryIcon